<template>
    <v-data-table :headers="headers" :items="items" hide-default-footer disable-sort :items-per-page="-1" class="v-data-table--default v-data-table--none-active-bg v-data-table--none-border-left data-table">
        <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" v-slot:[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
    </v-data-table>
</template>

<script>
const headers = [
    { width: "20%", align: "center", class: "white-space-pre", cellClass: "white-space-pre", value: "term", text: "①낙찰가\n(Hammer Price)" },
    { width: "20%", align: "center", class: "white-space-pre", cellClass: "white-space-pre", value: "a", text: "ⓐ1,000만원 일 경우" },
    { width: "20%", align: "center", class: "white-space-pre", cellClass: "white-space-pre", value: "b", text: "ⓑ5,000만원 일 경우" },
    { width: "20%", align: "center", class: "white-space-pre", cellClass: "white-space-pre", value: "c", text: "ⓒ1억원 일 경우" },
    { width: "20%", align: "center", class: "white-space-pre", cellClass: "white-space-pre", value: "desc", text: "비고" },
];

const items = [
    { term: "②낙찰수수료\n(Buyer's Premium)", a: "100만원", b: "500만원", c: "1,000만원", desc: "①낙찰가×10%\n(일괄적용)" },
    { term: "③부가가치세\n(VAT)", a: "10만원", b: "50만원", c: "100만원", desc: "②낙찰수수료×10%" },
    { term: "④구매가\n(Purchase Price)", a: "1,110만원", b: "5,550만원", c: "1억 1,100만원", desc: "" },
];

export default {
    data: () => ({
        items,
        headers,
    }),
};
</script>

<style lang="scss" scoped>
.data-table ::v-deep .white-space-pre {
    white-space: pre;
}
</style>

